export default "__VITE_ASSET__CGYmgUQT__"